import React, { useEffect, useState } from "react";
import { IconArrowLeft } from "@tabler/icons-react";
import { Anchor, Box, Button, Center, Container, Group, Paper, PasswordInput, Text, TextInput, Title } from "@mantine/core";
import "./styles.scss";
import { Colors } from "../../lib/Data";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useForm } from "@mantine/form";
import { DefaultErrorNotification, DefaultSuccessNotification, validateEmail } from "../../lib/Methods";
import { PerformRequest, usePerformRequest } from "../../lib/usePerformRequest";
import { Endpoints } from "../../lib/Endpoints";
import AnimateOnLoad from "../../components/AnimateOnLoad";

const UpdatePassword: React.FC = () => {
  const { resetID } = useParams();
  const navigate = useNavigate();
  const { status } = usePerformRequest({
    method: "GET",
    route: Endpoints.GetVerifyResetLink(resetID as string),
  });
  useEffect(() => {
    if (status === 401) {
      DefaultErrorNotification("Link is expired!");
      navigate("/login");
    }
    if (status === 404) {
      DefaultErrorNotification("Link is invalid!");
      navigate("/login");
    }
  }, [status]);
  const passwordForm = useForm({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validate: {
      password: (value) => (value && value.length > 5 ? null : "At least 6 characters"),
      confirmPassword: (value, values) => (value && values.password === value ? null : "Passwords do not match"),
    },
  });

  const [isLoading, setLoading] = useState<boolean>(false);

  const ChangePassword = async () => {
    const { hasErrors } = passwordForm.validate();
    if (!hasErrors) {
      setLoading(true);
      const { password } = passwordForm.values;
      const r = await PerformRequest({
        method: "PATCH",
        route: Endpoints.GetUpdatePassword(resetID as string),
        callback: () => {
          setLoading(false);
        },
        data: {
          password,
        },
      });
      setLoading(false);
      if (r) {
        if (r.status === 404) {
          DefaultErrorNotification("Account does not exist!");
        }
        if (r.status === 200) {
          DefaultSuccessNotification("Your password has been changed!");
          navigate("/login");
        }
      }
    }
  };
  return (
    <AnimateOnLoad>
      <div className="update-password-container flex-row">
        <div className="form">
          <Title className={"title"} ta="center">
            Update your Password
          </Title>
          <Text c="dimmed" fz="sm" ta="center">
            Create a new password
          </Text>

          <Paper withBorder shadow="md" p={20} radius="md" mt="xl">
            <PasswordInput {...passwordForm.getInputProps("password")} label="New Password" placeholder="Create a new password" required />
            <br />
            <PasswordInput
              {...passwordForm.getInputProps("confirmPassword")}
              label="Confirm Password"
              placeholder="Enter password again"
              required
            />
            <Group justify="space-between" mt="lg" className={"controls"}>
              <Anchor c="dimmed" size="sm" className={"control"}>
                <Link to="/login">
                  <Center inline c="dimmed">
                    <IconArrowLeft size={12} stroke={1.5} />
                    <Box ml={5}>Back to Login</Box>
                  </Center>
                </Link>
              </Anchor>
              <Button color={Colors.GreenPrimary} onClick={ChangePassword} className={"control"} loading={isLoading}>
                Update password
              </Button>
            </Group>
          </Paper>
        </div>
      </div>
    </AnimateOnLoad>
  );
};
export default UpdatePassword;
